/* eslint-disable class-methods-use-this */
/* eslint-disable no-constructor-return */
import BaseApi from '@/api/Base/BaseApi'
import UserApi from '@/api/User/UserApi'
import WorkspaceApi from '@/api/Workspace/WorkspaceApi'
import NotificationApi from '@/api/Notification/NotificationApi'
import DatabaseApi from '@/api/Database/DatabaseApi'
import DashboardApi from '@/api/Dashboard/DashboardApi'
import ProjectApi from '@/api/Project/ProjectApi'
import StorageApi from '@/api/Storage/StorageApi'
import DatasetNodeApi from '@/api/DatasetNode/DatasetNodeApi'
import LabelingNodeApi from '@/api/LabelingNode/LabelingNodeApi'
import LabelingNodeReviewApi from '@/api/LabelingNode/LabelingNodeReviewApi'
import ClassGroupApi from '@/api/ClassGroup/ClassGroupApi'
import ModelNodeApi from '@/api/ModelNode/ModelNodeApi'
import ValidationNodeApi from '@/api/ValidationNode/ValidationNodeApi'
import InferenceNodeApi from '@/api/InferenceNode/InferenceNodeApi'
import HyperparametersApi from '@/api/Hyperparameters/HyperparametersApi'
import InvitationApi from '@/api/Invitation/InvitationApi'
import ImageMatchingNodeApi from '@/api/ImageMatchingNode/ImageMatchingNodeApi'
import PreprocessingNodeApi from '@/api/PreprocessingNode/PreprocessingNodeApi'
import PreprocessingResultNodeApi from '@/api/PreprocessingResultNode/PreprocessingResultNodeApi'
import RoiNodeApi from '@/api/RoiNode/RoiNodeApi'
import InquiryApi from '@/api/Inquiry/InquiryApi'
import TaskApi from '@/api/Task/TaskApi'
import OnPremiseApi from '@/api/OnPremise/OnPremiseApi'
import ModelVersionApi from '@/api/ModelVersion/ModelVersionApi'
import DataDriftNodeApi from '@/api/DataDrift/DataDriftNodeApi'
import ModelDriftNodeApi from '@/api/ModelDrift/ModelDriftApi'
import ModelPerformanceApi from '@/api/ModelPerformance/ModelPerformanceApi'
import ManualApi from '@/api/Manual/ManualApi'
import ModelRetrainNodeApi from '@/api/ModelRetrainNode/ModelRetrainNodeApi'
import ModelRetrainEvaluationNodeApi from '@/api/ModelRetrainEvaluationNode/ModelRetrainEvaluationNodeApi'
import OcrApi from '@/api/Ocr/OcrApi'
import FileProcessingApi from '@/api/FileProcessing/FileProcessingApi'
import ModelSourceNodeApi from '@/api/ModelSourceNode/ModelSourceNodeApi'
import ModelPipelineInstanceNodeApi from '@/api/ModelPipelineInstanceNode/ModelPipelineInstanceNodeApi'
import GateNodeApi from '@/api/GateNode/GateNodeApi'
import ModelPipelineResultNodeApi from '@/api/ModelPipelineResultNode/ModelPipelineResultNodeApi'
import MergeNodeApi from '@/api/MergeNode/MergeNodeApi'
import ModelPipelineApi from '@/api/ModelPipeline/ModelPipelineApi'
import DataCollectionApi from '@/api/DataCollection/DataCollectionApi'
import DataStreamingNodeApi from '@/api/DataStreamingNode/DataStreamingNodeApi'
import TabularApi from '@/api/Tabular/TabularApi'
import CreditApi from '@/api/Credit/CreditApi'

class Api extends BaseApi {
  static proto: Api

  #instance: Api | undefined

  constructor(signal?: AbortSignal, isInstance = false) {
    super(signal)
    this.#instance = this

    if (isInstance) {
      return this.#instance
    }
    if (Api.proto) {
      return Api.proto
    }
    Api.proto = this
  }

  withSignal(signal: AbortSignal) {
    return new Api(signal, true)
  }

  User = new UserApi(this.signal)

  Inquiry = new InquiryApi(this.signal)

  Workspace = new WorkspaceApi(this.signal)

  Notifications = new NotificationApi(this.signal)

  Project = new ProjectApi(this.signal)

  Database = new DatabaseApi(this.signal)

  Dashboard = new DashboardApi(this.signal)

  Storage = new StorageApi(this.signal)

  DatasetNode = new DatasetNodeApi(this.signal)

  Preprocessing = new PreprocessingNodeApi(this.signal)

  PreprocessingResult = new PreprocessingResultNodeApi(this.signal)

  Labeling = new LabelingNodeApi(this.signal)

  LabelingReview = new LabelingNodeReviewApi(this.signal)

  ClassGroup = new ClassGroupApi(this.signal)

  ImageMatching = new ImageMatchingNodeApi(this.signal)

  ModelNode = new ModelNodeApi(this.signal)

  ValidationNode = new ValidationNodeApi(this.signal)

  InferenceNode = new InferenceNodeApi(this.signal)

  Hyperparameters = new HyperparametersApi(this.signal)

  Invitation = new InvitationApi(this.signal)

  RoiNode = new RoiNodeApi(this.signal)

  Task = new TaskApi(this.signal)

  OnPremise = new OnPremiseApi(this.signal)

  ModelVersion = new ModelVersionApi(this.signal)

  DataDrift = new DataDriftNodeApi(this.signal)

  ModelDrift = new ModelDriftNodeApi(this.signal)

  ModelPerformance = new ModelPerformanceApi(this.signal)

  Manual = new ManualApi(this.signal)

  Ocr = new OcrApi(this.signal)

  ModelRetrain = new ModelRetrainNodeApi(this.signal)

  ModelRetrainEvaluation = new ModelRetrainEvaluationNodeApi(this.signal)

  FileProcessing = new FileProcessingApi(this.signal)

  ModelSource = new ModelSourceNodeApi(this.signal)

  ModelPipelineInstance = new ModelPipelineInstanceNodeApi(this.signal)

  Gate = new GateNodeApi(this.signal)

  Merge = new MergeNodeApi(this.signal)

  ModelPipelineResult = new ModelPipelineResultNodeApi(this.signal)

  ModelPipeline = new ModelPipelineApi(this.signal)

  DataCollection = new DataCollectionApi(this.signal)

  DataStreaming = new DataStreamingNodeApi(this.signal)

  Tabular = new TabularApi(this.signal)

  Credit = new CreditApi()
}

export const API = () => new Api()
